import { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-akihabara': 'https://readdy.ai/api/search-image?query=Warm%20elegant%20aesthetic%20illustration%20of%20Akihabara%20maid%20cafe%20street%20scene%2C%20soft%20pastel%20tones%2C%20neon%20signs%20with%20warm%20glow%2C%20delicate%20lace%20textures%2C%20editorial%20photography%20style%2C%20warm%20cream%20and%20rose%20color%20palette%2C%20cultural%20depth&width=1200&height=630&seq=article-akihabara-hero&orientation=landscape',
  'article-maid-design': 'https://readdy.ai/api/search-image?query=Elegant%20Victorian%20style%20maid%20cafe%20interior%20design%2C%20lace%20curtains%20and%20warm%20lighting%2C%20vintage%20teacups%2C%20soft%20rose%20and%20cream%20palette%2C%20editorial%20photography&width=1200&height=630&seq=article-maid-design-hero&orientation=landscape',
  'article-maid-guide': 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20maid%20cafe%20entrance%2C%20open%20door%20with%20warm%20light%2C%20soft%20pastel%20tones%2C%20delicate%20lace%2C%20editorial%20photography%2C%20warm%20cream%20and%20rose%20palette&width=1200&height=630&seq=article-maid-guide-hero&orientation=landscape',
  'article-psychology': 'https://readdy.ai/api/search-image?query=Elegant%20psychological%20concept%20art%20about%20identity%20and%20roles%2C%20soft%20surreal%20illustration%20with%20mirror%20reflection%2C%20warm%20rose%20and%20cream%20tones%2C%20editorial%20style&width=1200&height=630&seq=article-psychology-hero&orientation=landscape',
  'article-cosplay-maid': 'https://readdy.ai/api/search-image?query=Elegant%20cosplay%20convention%20with%20maid%20costumes%2C%20soft%20lighting%20on%20fabric%2C%20artistic%20composition%2C%20warm%20pastel%20tones%2C%20editorial%20photography&width=1200&height=630&seq=article-cosplay-maid-hero&orientation=landscape',
  'article-male-maid': 'https://readdy.ai/api/search-image?query=Elegant%20butler%20and%20maid%20theme%20illustration%2C%20gender%20diversity%20in%20service%2C%20warm%20inviting%20atmosphere%2C%20soft%20cream%20and%20brown%20tones&width=1200&height=630&seq=article-male-maid-hero&orientation=landscape',
  'article-daily-routine': 'https://readdy.ai/api/search-image?query=Elegant%20morning%20routine%20with%20soft%20sunlight%20through%20lace%20curtains%2C%20vintage%20vanity%2C%20warm%20cream%20and%20rose%20tones%2C%20editorial%20photography&width=1200&height=630&seq=article-daily-routine-hero&orientation=landscape',
  'article-maid-fashion': 'https://readdy.ai/api/search-image?query=Elegant%20vintage%20maid%20uniform%20display%2C%20lace%20apron%20and%20ribbon%2C%20soft%20warm%20lighting%2C%20cream%20and%20rose%20palette%2C%20editorial%20fashion%20photography&width=1200&height=630&seq=article-maid-fashion-hero&orientation=landscape',
  'article-community': 'https://readdy.ai/api/search-image?query=Warm%20group%20of%20friends%20in%20cozy%20cafe%2C%20soft%20laughter%20and%20connection%2C%20cream%20and%20rose%20tones%2C%20editorial%20photography&width=1200&height=630&seq=article-community-hero&orientation=landscape',
  'article-anime-archetypes': 'https://readdy.ai/api/search-image?query=Elegant%20anime%20style%20illustration%20of%20maid%20characters%2C%20soft%20watercolor%20effect%2C%20warm%20pastel%20cream%20and%20rose%20tones%2C%20editorial%20composition&width=1200&height=630&seq=article-anime-archetypes-hero&orientation=landscape',
  'article-maid-games': 'https://readdy.ai/api/search-image?query=Elegant%20video%20game%20concept%20art%20featuring%20maid%20characters%2C%20soft%20digital%20painting%2C%20warm%20cream%20and%20rose%20palette%2C%20editorial%20aesthetic&width=1200&height=630&seq=article-maid-games-hero&orientation=landscape',
  'article-doujin': 'https://readdy.ai/api/search-image?query=Elegant%20fan%20art%20illustration%20collection%2C%20creative%20artistic%20works%2C%20soft%20warm%20lighting%2C%20cream%20and%20rose%20tones%2C%20editorial%20photography&width=1200&height=630&seq=article-doujin-hero&orientation=landscape',
  'article-first-month': 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20woman%20in%20maid%20uniform%2C%20soft%20natural%20light%2C%20cream%20and%20rose%20tones%2C%20editorial%20photography%2C%20emotional&width=1200&height=630&seq=article-first-month-hero&orientation=landscape',
  'article-quit-stay': 'https://readdy.ai/api/search-image?query=Elegant%20crossroads%20concept%2C%20two%20paths%20in%20warm%20light%2C%20soft%20cream%20and%20rose%20tones%2C%20editorial%20composition&width=1200&height=630&seq=article-quit-stay-hero&orientation=landscape',
  'article-maid-skills': 'https://readdy.ai/api/search-image?query=Elegant%20illustration%20of%20multiple%20skills%20and%20talents%2C%20soft%20artistic%20collage%2C%20warm%20cream%20and%20rose%20palette%2C%20editorial&width=1200&height=630&seq=article-maid-skills-hero&orientation=landscape',
  'article-healing': 'https://readdy.ai/api/search-image?query=Warm%20healing%20concept%2C%20soft%20glowing%20heart%20in%20gentle%20hands%2C%20cream%20and%20rose%20tones%2C%20editorial%20composition&width=1200&height=630&seq=article-healing-hero&orientation=landscape',
  'article-regulars': 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20diverse%20people%20in%20cozy%20cafe%2C%20genuine%20smiles%2C%20soft%20cream%20and%20rose%20tones%2C%20editorial%20photography&width=1200&height=630&seq=article-regulars-hero&orientation=landscape',
  'article-boundary': 'https://readdy.ai/api/search-image?query=Elegant%20concept%20of%20gentle%20boundaries%2C%20soft%20translucent%20curtain%2C%20cream%20and%20rose%20tones%2C%20editorial%20composition&width=1200&height=630&seq=article-boundary-hero&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  const article = useMemo(
    () => articles.find((a) => a.slug === slug),
    [slug]
  );

  const relatedArticles = useMemo(
    () =>
      article
        ? articles
            .filter((a) => a.categorySlug === article.categorySlug && a.slug !== article.slug)
            .slice(0, 3)
        : [],
    [article]
  );

  const moreArticles = useMemo(
    () =>
      article
        ? articles
            .filter((a) => a.categorySlug !== article.categorySlug)
            .slice(0, 3)
        : [],
    [article]
  );

  if (!article) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-6">
              <i className="ri-file-unknow-line text-3xl"></i>
            </div>
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-3">
              文章未找到
            </h1>
            <p className="text-foreground-500 mb-6">
              你访问的文章不存在，可能已经被移除或链接有误。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const heroImage = articleImages[article.imageSeq] || articleImages['article-akihabara'];

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://alyonvc.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: article.categoryName,
        item: `https://alyonvc.cn/category/${article.categorySlug}`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: article.title,
        item: `https://alyonvc.cn/article/${article.slug}`,
      },
    ],
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: heroImage,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    publisher: {
      '@type': 'Organization',
      name: '女仆不只是工作编辑部',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://alyonvc.cn/article/${article.slug}`,
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${article.title} - 女仆不只是工作`,
    description: article.excerpt,
    url: `https://alyonvc.cn/article/${article.slug}`,
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <Navbar />
      <main className="pt-16">
        <article>
          <div className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
            <img
              src={heroImage}
              alt={article.title}
              className="w-full h-full object-cover"
              title={`${article.title} - 女仆不只是工作`}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/50"></div>
          </div>

          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="-mt-20 relative z-10 bg-background-50 rounded-lg p-6 md:p-8">
              <Breadcrumb
                items={[
                  { label: article.categoryName, href: `/category/${article.categorySlug}` },
                  { label: article.title },
                ]}
              />

              <div className="flex flex-wrap items-center gap-2 mb-4">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
                {article.title}
              </h1>

              <div className="flex items-center gap-4 pb-6 border-b border-background-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden">
                  <img
                    src={article.authorAvatar}
                    alt={article.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">
                    {article.author}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>阅读 {article.readTime}</span>
                  </div>
                </div>
              </div>

              <div
                className="article-content prose prose-sm md:prose-base max-w-none mt-6"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </div>
          </div>
        </article>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          {relatedArticles.length > 0 && (
            <div className="mb-12">
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6">
                同分类推荐
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {relatedArticles.map((a) => (
                  <ArticleCard key={a.slug} article={a} />
                ))}
              </div>
            </div>
          )}

          {moreArticles.length > 0 && (
            <div>
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6">
                更多精彩
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {moreArticles.map((a) => (
                  <ArticleCard key={a.slug} article={a} />
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}